module.exports = __webpack_public_path__ + "static/media/32_(c)_stephan_anders.b54edeb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/0768/impressionen/32_(c)_stephan_anders.jpg
// module id = 1436
// module chunks = 0